export interface PostChartPayload {
  query: string;
  conversation_id: string;
}

export interface PutVotePayload {
  message_id: string;
  vote: string;
  downvote_reason: string | null;
}

// create an enum to match the backend ConfirmationType
export enum ConfirmationType {
  YES = "YES",
  NO = "NO",
}

export interface PutConfirmResponsePayload {
  message_id: string;
  confirmation: ConfirmationType;
}

export interface ConfirmResponse {
  successful: boolean;
}

export interface FavoriteResponse {
  successful: boolean;
}
